module.exports = __webpack_public_path__ + "static/media/nse.c0005ab4.jpg";